export default __webpack_public_path__ + "static/logo1100-2e1a158feaea5947bee6c1a1abc4bd3a.png";